import { render, staticRenderFns } from "./TakipHarcVarTaslak.vue?vue&type=template&id=5396e8f1"
import script from "./TakipHarcVarTaslak.vue?vue&type=script&lang=ts"
export * from "./TakipHarcVarTaslak.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports